var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-card",on:{"click":_vm.selectImage}},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageUrl,"alt":_vm.imageRef.name},on:{"load":_vm.resizeImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }